import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHotDrinkCup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"hot-drink-cup,coffee-mug,dup, mug"} maskId="square-filled-radius-0-stroke-1-IconHotDrinkCup"><path fillRule="evenodd" clipRule="evenodd" d="M5.64662 2H18.3534L19.4156 5H21V9H19.974L18.4446 22H5.55538L4.02596 9H3V5H4.58442L5.64662 2ZM5.64525 5H18.3548L17.6466 3H6.35338L5.64525 5ZM20 8V6H4V8H20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHotDrinkCup;
